const ENV = process.env.NODE_ENV;
const IS_PROD = ENV === 'production';

// 在生产仅保留 error，其他环境默认 debug
const DEFAULT_LEVEL = IS_PROD ? 'error' : 'debug';

const levelOrder = {
  silent: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
  log: 5,
};

let currentLevel = DEFAULT_LEVEL;
const sinks = [];

export const setLogLevel = (level) => {
  currentLevel = level;
};

export const registerLogSink = (sink) => {
  sinks.push(sink);
};

export const mob = (event, eventType, payload, immediate = false) => {
  try {
    const body = { mob: event, event_type: eventType, ...(payload || {}) };
    sinks.forEach((s) => {
      s.emit('info', body);
      if (immediate && s.flush) s.flush();
    });
  } catch {
    // swallow
  }
};

const shouldPrint = (level) => levelOrder[level] <= levelOrder[currentLevel] && currentLevel !== 'silent';

const withPrefix = (level, args) => [
  `%c[${level.toUpperCase()}]%c`,
  'color:#888;font-weight:bold',
  'color:inherit',
  ...args,
];

export const logger = {
  get level() { return currentLevel; },
  setLevel: setLogLevel,
  log: (...args) => { if (shouldPrint('log')) { console.log(...withPrefix('log', args)); sinks.forEach(s => s.emit('log', args)); } },
  debug: (...args) => { if (shouldPrint('debug')) { console.debug(...withPrefix('debug', args)); sinks.forEach(s => s.emit('debug', args)); } },
  info: (...args) => { if (shouldPrint('info')) { console.info(...withPrefix('info', args)); sinks.forEach(s => s.emit('info', args)); } },
  warn: (...args) => { if (shouldPrint('warn')) { console.warn(...withPrefix('warn', args)); sinks.forEach(s => s.emit('warn', args)); } },
  error: (...args) => { if (shouldPrint('error')) { console.error(...withPrefix('error', args)); sinks.forEach(s => s.emit('error', args)); } },
};

export const installConsoleProxy = () => {
  const original = {
    log: console.log.bind(console),
    debug: console.debug.bind(console),
    info: console.info.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
  };

  console.log = (...args) => { if (shouldPrint('log')) original.log(...withPrefix('log', args)); };
  console.debug = (...args) => { if (shouldPrint('debug')) original.debug(...withPrefix('debug', args)); };
  console.info = (...args) => { if (shouldPrint('info')) original.info(...withPrefix('info', args)); };
  console.warn = (...args) => { if (shouldPrint('warn')) original.warn(...withPrefix('warn', args)); };
  console.error = (...args) => { if (shouldPrint('error')) original.error(...withPrefix('error', args)); };

  if (IS_PROD) {
    setLogLevel('error');
  }
};

export default logger;


